<script setup>
useHead({
  htmlAttrs: {
    class: "layout-chat",
  },
});
</script>

<template>
  <main class="chat">
    <MainHeader class="header"></MainHeader>
    <slot />
  </main>
</template>

<style lang="scss">
html.layout-chat {
  background-color: var(--main-body-background-color);
  color: var(--main-body-text-color);
}

html.layout-chat a {
  color: var(--main-body-text-color);
  text-decoration: none;
}
</style>

<style lang="scss" scoped>
.chat {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: stretch;
  align-self: center;
  width: 100%;
  max-height: 100%;
  text-align: center;
}
</style>
